import { isPC } from '@/utils'
export default {
  YesOrNo: [
    { value: 0, label: '否' },
    { value: 1, label: '是' }
  ],
  platformMap: {},
  departmentType: [
    { value: 1, label: '市场' },
    { value: 2, label: '运营' },
    { value: 3, label: '设计' }
  ],
  // 媒体类型
  TOUTIAO: 1,
  TENCENT: 2,
  KUAISHOU: 3,
  BAIDU: 4,
  MP: 5,
  UC: 6,
  IQIYI: 10,
  BAIDU_SEARCH: 14,
  SHENMA_SEARCH: 16,
  DOUYIN_STAR: 21,
  TOUTIAO_APP: 23,
  QIHU_SEARCH: 24, // 360 又名奇虎
  HUYA: 29,
  WEIBO: 85,
  TOUTIAO_PINPAI: 108,
  OPPO: 151,
  BILIBILI: 163,
  KUAISHOU_PINPAI: 164,
  JN_PUSH: 168,
  HUAWEI: 177,
  ASA: 184,
  FACEBOOK: 181,
  TAPTAP: 195,
  TAP_UNION: 422,
  TIKTOK: 205,
  QIHU_JINGJIA: 210,
  TWITTER: 216,
  XINGTU: 221,
  NETEASE_YOUDAO: 239,
  YOUTUBE: 243,
  XIAOHONGSHU: 253,
  DOUYIN: 255,
  QIANCHUAN: 256,
  HONOR: 258,
  ALIPAY: 260,
  NETEASE_NEWS: 273,
  VIVO: 289,
  HUAWEI_JINGHONG: 311,
  HUAWEI_MONETIZATION: 344,
  ZHIHU_XINXILIU: 403, // 知乎信息流
  YIXIN: 464, // 一新
  media: [{
    value: 1,
    label: '今日头条'
  }, {
    value: 2,
    label: '广点通'
  }, {
    value: 3,
    label: '快手'
  }, {
    value: 4,
    label: '百度'
  }, {
    value: 5,
    label: '微信'
  }, {
    value: 6,
    label: 'UC汇川'
  }, {
    value: 10,
    label: '爱奇艺'
  }, {
    value: 14,
    label: '百度搜索'
  }, {
    value: 16,
    label: '神马搜索'
  }, {
    value: 23,
    label: '头条应用管理中心'
  }, {
    value: 24,
    label: '360搜索'
  }, {
    value: 29,
    label: '虎牙'
  }, {
    value: 85,
    label: '微博'
  }, {
    value: 151,
    label: 'OPPO'
  }, {
    value: 163,
    label: '哔哩哔哩'
  }, {
    value: 164,
    label: '快手品牌'
  }, {
    value: 168,
    label: '锦囊智推'
  }, {
    value: 177,
    label: '华为'
  }, {
    value: 184,
    label: 'ASA'
  }, {
    value: 186,
    label: 'Google'
  }, {
    value: 181,
    label: 'Facebook'
  }, {
    value: 195,
    label: 'Taptap'
  }, {
    value: 422,
    label: 'Tap联盟'
  }, {
    value: 205,
    label: 'Tiktok'
  }, {
    value: 210,
    label: '360竞价'
  }, {
    value: 216,
    label: 'Twitter'
  }, {
    value: 221,
    label: '星图'
  }, {
    value: 239,
    label: '网易有道'
  }, {
    value: 243,
    label: 'Youtube'
  }, {
    value: 253,
    label: '小红书'
  }, {
    value: 255,
    label: '抖音'
  }, {
    value: 256,
    label: '千川'
  }, {
    value: 258,
    label: '荣耀'
  }, {
    value: 260,
    label: '支付宝'
  }, {
    value: 273,
    label: '网易新闻'
  }, {
    value: 289,
    label: 'VIVO'
  }, {
    value: 311,
    label: '华为鲸鸿动能'
  }, {
    value: 344,
    label: '华为流量变现'
  }, {
    value: 346,
    label: 'ZB粉丝群'
  }, {
    value: 403,
    label: '知乎信息流'
  }, {
    value: 464,
    label: '一新'
  }],
  platIdMap: [{
    value: 1,
    label: '页游'
  }, {
    value: 2,
    label: '手游'
  }, {
    value: 3,
    label: 'H5'
  }, {
    value: 7,
    label: '小游戏'
  }, {
    value: 8,
    label: 'PC端游'
  }, {
    value: 9,
    label: '快游戏'
  }, {
    value: 10,
    label: '抖音小游戏'
  }, {
    label: '美团小游戏',
    value: 11
  },
  {
    label: '快手小游戏',
    value: 12
  },
  {
    label: 'QQ小游戏',
    value: 13
  },
  {
    label: '字节小程序',
    value: 14
  },
  {
    label: '支付宝小游戏',
    value: 15
  },
  {
    label: '华为小游戏',
    value: 17
  },
  {
    label: '百度小游戏',
    value: 18
  }],
  authMediaTypeList: [1, 2, 3, 4, 5, 6, 10, 14, 16, 24, 85, 151, 163, 177, 181, 184, 195, 205, 210, 216, 221, 243, 253, 255, 256, 258, 260, 289, 311, 422],
  isPC: isPC(),
  domain: 'https://dms.zx.com',
  downloadDomain: 'https://download.zxzt123.com',
  majordomoMedia() {
    return [
      this.MP
    ]
  },
  /**
   * @param  {Array} mediaTypes
   * @return {Array}
   */
  mediaOptions(mediaTypes = []) {
    return this.media.filter(item => mediaTypes.indexOf(item.value) !== -1)
  },
  modules: [
    { value: 'DMS', name: '数据中心' },
    { value: 'DSP', name: '投放中心' },
    { value: 'ERP', name: '进销存中心' },
    { value: 'LY', name: '发行中心' },
    { value: 'FA', name: '人事管理' }
  ]
}
